



















import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class MotionModal extends Vue {
  public modal = false;
  public form = { tips: "" };
  public uid = "";
  public show(uid) {
    Object.assign(this.$data, (this as any).$options.data.call(this));
    this.uid = uid;
    this.modal = true;
  }
  public submit() {
    this.$emit("submit", this.uid, this.form.tips);
  }
}
